import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map, startWith, shareReplay} from 'rxjs/operators';
import {timeUtil} from '@px/helper/time';
import {mockUtil} from '@px/helper/moc';
import {wwData$} from '@px/streams/worker-data';
import {userInfo$} from '@px/streams/user';
import {isUtaSpot$} from '@px/streams/uta-state';
import {contract$} from '@px/streams/contract';
import {genShareReplyWithSubscribeHook} from '@px/helper/stream';

export const contractPTDiscountState$ = genShareReplyWithSubscribeHook<boolean>(
  wwData$.pipe(
    filter((o) => o.type === 'contract-pt-discount-state'),
    map((o) => o.data.state),
    startWith(false)
  ),
  () => {
    wwData$.next({type: 'dynamic-subscribe', method: 'subscribeContractPtState'});
  }
);

export const supportContractPTDiscount$ = combineLatest([contract$, isUtaSpot$]).pipe(
  map(([contract, isUtaSpot]) => contract.settleCurrency === 'USDT' && !isUtaSpot),
  startWith(false),
  shareReplay(1)
);

// 是否支持浮盈加仓, 已全面放开支持
export const riskEngineMode$ = new BehaviorSubject<boolean>(true);
export const profitReinvestmentState$ = new BehaviorSubject({visible: false, msg: '', launchTime: ''});

userInfo$
  .pipe(
    filter((info) => info.userId > 0),
    map((info) => {
      const isMock = mockUtil.isMock();
      if (isMock) {
        return {visible: false, msg: 'mock 不需要提示', launchTime: ''};
      }

      // 方便测试
      const localTime = localStorage.getItem('profit_reinvestment_timeline');
      const times = localTime
        ? JSON.parse(localTime)
        : {
            now: Date.now(),
            deadline: Date.UTC(2024, 3, 19), // 主网新用户全部使用risk unit时间
            first: Date.UTC(2024, 4, 21),
            second: Date.UTC(2024, 4, 23),
            third: Date.UTC(2024, 4, 25),
          };
      const now = times.now;

      // 如果是2024-04-02之后注册的新用户直接使用浮盈加仓的逻辑，不适用灰度逻辑
      const {createTime, userId} = info;
      if (createTime > times.deadline) {
        return {visible: false, msg: '恭喜你不用灰度', launchTime: ''};
      }
      const firstGroup = [6, 7].includes(userId % 10);
      const secondGroup = [8, 9].includes(userId % 10);
      const thirdGroup = [10, 11, 12, 13, 14, 15].includes(userId % 20);

      if (now < times.first) {
        if (firstGroup) {
          return {visible: true, msg: '尾号为0, 1的预热开始', launchTime: timeUtil.formatUTCDate(times.first)};
        }
      } else if (now < times.second) {
        if (secondGroup) {
          return {visible: true, msg: '尾号为2, 3, 4, 5的预热开始', launchTime: timeUtil.formatUTCDate(times.second)};
        }
      } else if (now < times.third) {
        if (thirdGroup) {
          return {visible: true, msg: '尾号为6, 7, 8, 9的预热开始', launchTime: timeUtil.formatUTCDate(times.third)};
        }
      }
      return {visible: false, msg: '灰度结束了。。。', launchTime: ''};
    })
  )
  .subscribe((o) => profitReinvestmentState$.next(o));
